import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M23.61 11.29 13.39 1.08a1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3L9.22 3.83a1 1 0 0 0 0 1.39l3.14 3.37a.25.25 0 0 1 .05.27.25.25 0 0 1-.23.15H1.1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h11a.25.25 0 0 1 .23.15.25.25 0 0 1 0 .27l-3.14 3.35a1 1 0 0 0 0 1.39L12 22.93a1 1 0 0 0 1.42 0l10.19-10.22a1 1 0 0 0 0-1.42"
    }, null, -1)
  ]));
}
const arrowRight = { render };
export {
  arrowRight as default,
  render
};
//# sourceMappingURL=arrow-right.svg.js.map
